import jwtDecode from 'jwt-decode';
const AUTH_SESSION_KEY = 'agrostrongadminuser';
const challengeSessionKey = 'kmnslnaouhjdouiusyhndgsadsahnkjhdiuewqhndhginlu';

/**
 * Sets the default authorization
 * @param {*} token
 */

export const  getLoggedInUser = () => {
        return getUserFromCookie();
    };

 export const isUserAuthenticated = () => {
        const user = getLoggedInUser();

        if (!user) {
            return false;
        }
        const decoded  = jwtDecode(user.token);
        const currentTime = Date.now() / 1000;
        if (decoded.exp < currentTime) {
            return false;
        } else {
            return true;
        }
    };


    /**
     * Returns the logged in user
     */

 export const getDecodedUser =()=>{
        return isUserAuthenticated() && jwtDecode(getLoggedInUser().token);
    }


const getUserFromCookie = () => {
    const user = sessionStorage.getItem(AUTH_SESSION_KEY);
    return user ? (typeof user == 'object' ? user : JSON.parse(user)) : null;
};

export const  setLoggedInUser = (session) => {
        if (session) sessionStorage.setItem(AUTH_SESSION_KEY, JSON.stringify(session));
        else {
            sessionStorage.removeItem(AUTH_SESSION_KEY);
        }
    };

function makeid(length) {
var result           = '';
var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnop-qrstuvwxyz0123456789';
var charactersLength = characters.length;
for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
}
return result;
}


export const storeChallengeInCookie = (shouldStore) => {

        if (shouldStore) sessionStorage.setItem(challengeSessionKey, makeid(54));

        else {
            sessionStorage.removeItem(challengeSessionKey);
        }

    };

export const getChallengeInCookie=()=>{
        const challenge = sessionStorage.getItem(challengeSessionKey);

        return challenge;

    };
